import { render } from "./UserTypeSelectionSection.vue?vue&type=template&id=4ebd79fa"
import script from "./UserTypeSelectionSection.vue?vue&type=script&lang=js"
export * from "./UserTypeSelectionSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__